import axios from "axios";
import { SET_CUSTOM_ERROR } from "./errortypes";

export const customerrors = (errormessge, error) => async (dispatch) => {
  dispatch({
    type: SET_CUSTOM_ERROR,
    payload: { errormessge, error },
  });
};
